import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useSOPDetailQuery, useUpdateSOP } from "../api/queries";
import { SOPChangeWarning } from "../ui/SOPChangeWarning";
import { SOPForm } from "../ui/SOPForm";

export function SOPEditPage() {
  const nav = useNavigate({ from: "/app/sop/$id/edit" });
  const { id } = useParams({ from: "/app/sop/$id/edit" });
  const updateSOP = useUpdateSOP();
  const sopDetail = useSOPDetailQuery(id);

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-4">
            <h1 className="font-semibold text-2xl">ແກ້ໄຂ SOP</h1>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => nav({ to: "/app/sop" })}
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              ກັບ
            </Button>
          </div>

          <div className="rounded-lg border bg-card p-6">
            {sopDetail.isLoading ? (
              <div className="p-4 text-center">ກໍາລັງໂຫຼດ...</div>
            ) : sopDetail.data ? (
              <>
                <SOPChangeWarning sopId={id} />
                <SOPForm
                  initialValues={{
                    title: sopDetail.data.title,
                    purpose: sopDetail.data.purpose ?? null,
                    scope: sopDetail.data.scope ?? null,
                    departmentId: sopDetail.data.departmentId ?? null,
                    responsiblePersonId:
                      sopDetail.data.responsiblePersonId ?? null,
                    positionIds:
                      sopDetail.data.positionTags?.map((p) => p.positionId) ??
                      [],
                    steps:
                      sopDetail.data.steps?.map((step) => ({
                        id: step.id,
                        stepNumber: step.stepNumber,
                        title: step.title,
                        description: step.description ?? null,
                        responsibleId: step.responsibleId ?? null,
                        notes: step.notes ?? null,
                      })) ?? [],
                    documents:
                      sopDetail.data.documents?.map((doc) => ({
                        id: doc.id,
                        title: doc.title,
                        fileKey: doc.fileKey ?? null,
                      })) ?? [],
                    warnings:
                      sopDetail.data.warnings?.map((w) => w.warningText) ?? [],
                    status: sopDetail.data.status,
                  }}
                  onSubmit={async (values) => {
                    await updateSOP.mutateAsync({
                      id,
                      input: values,
                    });
                    nav({ to: "/app/sop" });
                  }}
                  submitting={updateSOP.isPending}
                />
              </>
            ) : (
              <div className="p-4 text-center text-destructive">ບໍ່ພົບຂໍ້ມູນ SOP</div>
            )}
          </div>
        </div>
      </Main>
    </>
  );
}
